import { alpha, Chip, type ChipProps } from '@mui/material';
import styled from '@emotion/styled';
import stripProps from '@/lib/utils/stripProps';
import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';

type StyledChipProps = Omit<ChipProps, 'color'> & {
  chipColor: string;
};

const StyledChip = styled(stripProps(Chip, 'chipColor'))<StyledChipProps>(
  ({ theme, chipColor }) => ({
    marginRight: 6,
    marginBottom: 6,
    color: theme.palette.getContrastText(chipColor),
    backgroundColor: chipColor,
    '.MuiChip-avatar': {
      color: theme.palette.getContrastText(chipColor),
      backgroundColor: alpha(theme.palette.getContrastText(chipColor), 0.2),
    },
    '.MuiSvgIcon-root': {
      color: alpha(theme.palette.getContrastText(chipColor), 0.7),
      '&:hover': {
        color: theme.palette.getContrastText(chipColor),
      },
    },
  }),
  addHighContrastStyles(({ theme }) => ({
    color: theme.palette.getContrastText(theme.palette.divider),
    backgroundColor: theme.palette.divider,
    '.MuiChip-avatar': {
      color: theme.palette.getContrastText(theme.palette.divider),
      backgroundColor: theme.palette.divider,
      border: `1px solid ${theme.palette.getContrastText(theme.palette.divider)}`,
    },
    '.MuiSvgIcon-root': {
      color: theme.palette.getContrastText(theme.palette.divider),
      '&:hover': {
        color: alpha(theme.palette.getContrastText(theme.palette.divider), 0.8),
      },
    },
  })),
);

export default StyledChip;
